var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentSuccessful(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 109,
    viewBox: "0 0 99 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3452 12.9709L20.5944 13.3301L22.9104 13.9836L69.0793 30.7682L71.0998 31.5925L73.0394 32.6391L74.8834 33.8848L76.617 35.3073L78.2247 36.8852L79.6912 38.5972L81.0004 40.4228L82.1356 42.3416L83.0797 44.3334L83.8148 46.3781L84.3223 48.4556L84.5826 50.5458L85.4048 96.1335L85.4049 96.1348L85.1279 98.3495L84.5826 100.398L83.7828 102.263L82.7429 103.924L81.4773 105.363L80.0014 106.558L78.3303 107.49L76.4814 108.135L74.4711 108.472L72.3188 108.479L70.0432 108.134L19.032 97.257L16.5396 96.681L13.9178 95.5574L11.4115 93.9299L9.16812 92.2377L7.11933 90.3056L5.29199 88.1665L3.71213 85.8538L2.40469 83.4017L1.39355 80.8448L0.701217 78.2178L0.348572 75.5545L0.355427 72.8899L4.40655 23.8033L4.7317 21.6665L5.36416 19.7386L6.27687 18.0302L7.44305 16.5512L8.83646 15.3107L10.4315 14.3172L12.2034 13.5787L14.1281 13.1031L16.1827 12.8979L18.3452 12.9709ZM85.4048 96.1335L84.5826 50.5458L85.3995 93.7711L85.4048 96.1335Z",
    fill: "url(#paint0_linear_59_1565)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5781 8.76863L14.253 10.9054L10.4088 63.8533L10.4019 66.5179L10.7545 69.1809L11.4469 71.8081L12.458 74.3651L13.7655 76.8172L15.3453 79.1298L17.1727 81.269L19.2215 83.2011L21.4648 84.8933L23.8752 86.314L26.4245 87.4326L29.0842 88.2202L83.6383 100.576L85.9137 100.921L88.0662 100.914L90.0762 100.577L91.9252 99.9319L90.0842 101.023L88.4197 101.951L86.6609 102.994L88.4189 101.951L88.4197 101.951L90.0842 101.023L91.9252 99.9319L93.5963 99.0007L90.0859 101.022L90.085 101.023L90.0842 101.023L88.4197 101.951L86.6609 102.994L83.3206 104.918L80.0612 106.795L78.414 107.714L76.5995 108.359L74.6352 108.71L72.5396 108.746L70.3318 108.444L17.6908 97.3198L15.1374 96.602L12.6963 95.5654L10.3942 94.2374L8.25743 92.6467L6.31182 90.8234L4.58259 88.7982L3.09412 86.6028L1.86986 84.2693L0.932181 81.8301L0.302262 79.3179L0 76.7653L0.0439053 74.2045L4.50804 23.0272L4.8536 20.949L5.49388 19.0661L8.74412 14.4371L9.89951 12.9721L12.3024 9.942L14.7646 6.83709L17.2871 3.65631L16.1233 5.13228L15.2106 6.84066L14.5781 8.76863Z",
    fill: "url(#paint1_linear_59_1565)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_3",
    filter: "url(#filter0_b_59_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1916 0.0730263L30.4408 0.43218L32.7568 1.08575L80.4452 17.4451L82.4658 18.2694L84.4054 19.316L86.2494 20.5617L87.9829 21.9842L89.5907 23.5621L91.0572 25.2741L92.3663 27.0997L93.5015 29.0185L94.4456 31.0103L95.1807 33.055L95.6882 35.1325L95.9485 37.2227L98.9999 88.5756L99 88.577L98.723 90.7916L98.1777 92.8401L97.3779 94.7047L96.338 96.3662L95.0724 97.8051L93.5965 99.0006L91.9254 99.9319L90.0765 100.577L88.0662 100.914L85.9139 100.921L83.6383 100.577L29.0854 88.2205L26.593 87.6444L23.9711 86.5208L21.4648 84.8933L19.2215 83.2011L17.1727 81.269L15.3453 79.1299L13.7655 76.8172L12.458 74.3651L11.4469 71.8082L10.7546 69.1812L10.4019 66.5179L10.4088 63.8533L14.253 10.9055L14.5781 8.76865L15.2106 6.84069L16.1233 5.1323L17.2895 3.65331L18.6829 2.41281L20.2779 1.41929L22.0498 0.680824L23.9745 0.205164L26.0291 0L28.1916 0.0730263ZM98.9999 88.5756L95.9485 37.2227L98.9946 86.2132L98.9999 88.5756Z",
    fill: "url(#paint2_linear_59_1565)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4981 88.5606L98.2311 90.6958L97.7038 92.6764L96.9336 94.4721L95.9357 96.0666L94.7249 97.4432L93.3153 98.5848L91.7199 99.474L89.9519 100.091L88.0238 100.414L85.9507 100.421L83.7311 100.085L29.1979 87.7333L29.1958 87.7328L26.7489 87.1673L24.2075 86.0781L21.7519 84.4835L19.5445 82.8185L17.5354 80.9238L15.743 78.8256L14.1938 76.5578L12.9126 74.1549L11.9228 71.652L11.2461 69.0843L10.902 66.4856L10.9087 63.8721L14.7502 10.9613L15.0662 8.88499L15.6721 7.0379L16.5434 5.40705L17.6548 3.99748L18.9834 2.81464L20.5078 1.86518L22.2068 1.15705L24.0597 0.699138L26.0456 0.500841L28.1435 0.571689L30.3331 0.921319L32.6076 1.56319L80.2695 17.9134L82.252 18.7222L84.1461 19.7442L85.9502 20.963L87.6485 22.3567L89.225 23.9038L90.6634 25.583L91.9472 27.3732L93.0595 29.2534L93.9834 31.2024L94.7013 33.1993L95.1956 35.223L95.4503 37.2684L98.4981 88.5606Z",
    stroke: "url(#paint3_linear_59_1565)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter1_d_59_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2518 42.0546L35.395 39.7599L32.8546 42.4805L33.2518 42.0546ZM84.9595 43.9346L56.1162 65.3043L56.1136 65.3062L55.6058 65.6202L55.0573 65.8448L54.476 65.9815L53.87 66.0317L53.2475 65.9972L52.6167 65.8796L51.986 65.6807L51.3638 65.4023L50.7587 65.0465L49.8597 66.205L48.9608 67.3636L49.5762 67.6362L50.2004 67.8302L50.8252 67.9438L51.4422 67.9751L52.0432 67.9227L52.6202 67.7848L53.1651 67.56L53.6702 67.2469L82.4222 45.9304L82.4237 45.9293L84.9595 43.9346ZM34.9961 40.1877L32.8546 42.4805L32.5371 42.9626L32.2999 43.4929L32.1441 44.0635L32.0704 44.6663L32.0798 45.293L32.1728 45.9353L32.3502 46.5846L32.6125 47.2326L32.9602 47.8705L33.3935 48.4898L46.7562 65.5267L47.2519 66.0935L47.7902 66.5901L48.3626 67.0142L48.9608 67.3636L49.8597 66.205L50.7587 65.0465L50.1791 64.6153L49.6335 64.111L49.1307 63.5359L35.5666 46.2587L35.1264 45.6309L34.7727 44.9848L34.5051 44.329L34.3231 43.6723L34.2264 43.0233L34.2142 42.3904L34.2859 41.7822L34.4406 41.2069L34.6777 40.6727L34.9961 40.1877ZM34.9961 40.1877L35.395 39.7599L32.8546 42.4805L34.9961 40.1877Z",
    fill: "url(#paint4_linear_59_1565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7242 37.9624L85.1075 38.5111L85.4259 39.0733L85.6792 39.6423L85.8671 40.2113L85.9892 40.7736L86.0451 41.3223L86.0344 41.8504L85.9564 42.351L85.8106 42.817L85.5963 43.2411L85.3128 43.6161L84.9596 43.9346L56.1156 65.3048L56.1137 65.3062L55.6059 65.6202L55.0574 65.8447L54.476 65.9814L53.8701 66.0317L53.2475 65.9972L52.6167 65.8796L51.986 65.6807L51.3638 65.4023L50.7587 65.0464L50.1791 64.6153L52.8462 53.9151L78.8689 36.0153L79.2871 35.7828L79.7409 35.6307L80.2232 35.5563L80.7273 35.557L81.246 35.63L81.7727 35.7729L82.3005 35.9831L82.8228 36.2581L83.333 36.5958L83.8243 36.9938L84.2902 37.45L84.7242 37.9624ZM34.286 41.7819L34.4407 41.2068L34.6776 40.6729L36.4131 39.1156L38.8602 38.8653L39.5022 39.0076L40.1399 39.2264L40.7652 39.5193L41.37 39.8839L41.9465 40.3179L42.4866 40.819L42.9824 41.3853L52.8462 53.9151L50.1791 64.6153L49.6336 64.1109L49.1307 63.5358L35.5665 46.2586L35.1265 45.6309L34.7727 44.9848L34.5051 44.329L34.3232 43.6723L34.2264 43.0232L34.2142 42.3904L34.286 41.7819ZM38.8602 38.8653L38.222 38.8023L37.5959 38.8211L36.9901 38.9245L36.4131 39.1156L38.8602 38.8653ZM36.4131 39.1156L35.8735 39.397L35.3951 39.7598L34.9961 40.1876L34.6776 40.6729L36.4131 39.1156Z",
    fill: "url(#paint5_linear_59_1565)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_59_1565",
    x: -2.59808,
    y: -13,
    width: 114.598,
    height: 126.921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_1565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_1565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_59_1565",
    x: 15.3651,
    y: 30.916,
    width: 79.9607,
    height: 58.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.71229,
    dy: 8.35266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.49651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103333 0 0 0 0 0.4104 0 0 0 0 0.43 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_1565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_1565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_1565",
    x1: 2.8156,
    y1: 114.48,
    x2: 80.5916,
    y2: 19.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320833,
    stopColor: "#C0EEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58125,
    stopColor: "#8FC3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "#2A9FAF",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_1565",
    x1: -22.9861,
    y1: 17.8984,
    x2: 85.7825,
    y2: 126.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35896,
    stopColor: "#39B8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683604,
    stopColor: "#089EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68A4B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_1565",
    x1: 13.2175,
    y1: 104.72,
    x2: 90.9935,
    y2: 10.2004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320833,
    stopColor: "#009DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685417,
    stopColor: "#009DE0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "#009DE0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_1565",
    x1: 10.2424,
    y1: 91.1963,
    x2: 96.3093,
    y2: 18.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180663,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533255,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_1565",
    x1: 29.6036,
    y1: 18.9936,
    x2: 30.2237,
    y2: 74.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.301696,
    stopColor: "#C5E7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993284,
    stopColor: "#7FB8C0",
    stopOpacity: 0.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_1565",
    x1: 55.9579,
    y1: 75.3834,
    x2: 83.8731,
    y2: 25.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644664,
    stopColor: "white",
    stopOpacity: 0.57
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessful);
export default __webpack_public_path__ + "static/media/paymentSuccessful.30f86e8236f9b054c49e4aa9d757fc3a.svg";
export { ForwardRef as ReactComponent };